import React from 'react';
import { Zap } from 'lucide-react';
import { NumericFormat } from 'react-number-format';
import { CURRENCIES } from '../../utils/currencyUtils';

interface PowerCostInputProps {
  powerCost: number;
  currency: string;
  onPowerCostChange: (cost: number) => void;
  onCurrencyChange: (currency: string) => void;
}

export function PowerCostInput({ 
  powerCost, 
  currency,
  onPowerCostChange,
  onCurrencyChange
}: PowerCostInputProps) {
  const selectedCurrency = CURRENCIES.find(c => c.code === currency) || CURRENCIES[0];

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Power Cost Settings</h2>
      <div className="flex items-center gap-4">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Electricity Cost per kWh
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Zap className="w-5 h-5 text-gray-400" />
            </div>
            <NumericFormat
              value={powerCost}
              onValueChange={(values) => onPowerCostChange(values.floatValue || 0)}
              decimalScale={4}
              fixedDecimalScale
              allowNegative={false}
              prefix={selectedCurrency.symbol}
              className="block w-full pl-10 pr-3 py-2 text-lg bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter cost per kWh"
            />
          </div>
          <p className="mt-2 text-sm text-gray-500">
            Enter your local electricity cost per kilowatt-hour
          </p>
        </div>
      </div>
    </div>
  );
}